import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcLeftArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 51,
	viewBox: "0 0 30 51",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27.9041 48.8738C29.6208 47.1267 29.6159 44.3247 27.893 42.5838L14.0802 28.6266C12.1535 26.6797 12.1518 23.5451 14.0763 21.5962L27.8981 7.59944C29.617 5.85882 29.6154 3.05925 27.8947 1.3205C26.1471 -0.445375 23.2942 -0.445376 21.5466 1.3205L1.48072 21.5962C-0.447455 23.5445 -0.44746 26.6821 1.48071 28.6304L21.5258 48.885C23.283 50.6606 26.1531 50.6556 27.9041 48.8738Z",
		fill: "currentColor"
	})
});
export default SvgIcLeftArrow;
